/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminUpdateVideoOptions, AdminUpdateVideoStatus200, AdminUpdateVideoStatus422 } from '../models/AdminUpdateVideo'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { adminUpdateVideo } from '../clients/axios/adminUpdateVideo'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const adminUpdateVideoMutationKey = () => [{ url: '/admin/video/:video_id' }] as const

export function adminUpdateVideoMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = adminUpdateVideoMutationKey()
  return mutationOptions<AdminUpdateVideoStatus200, ResponseErrorConfig<AdminUpdateVideoStatus422>, AdminUpdateVideoOptions, TContext>({
    mutationKey,
    mutationFn: async({ path, body }) => {
      return await adminUpdateVideo({ ...config, path, body, throwOnError: true })
    },
  })
}

/**
 * @summary Update Video
 * {@link /admin/video/:video_id}
 */
export function useAdminUpdateVideo<TContext>(options: {
  mutation?: UseMutationOptions<AdminUpdateVideoStatus200, ResponseErrorConfig<AdminUpdateVideoStatus422>, AdminUpdateVideoOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? adminUpdateVideoMutationKey()

  const baseOptions = adminUpdateVideoMutationOptions(config) as UseMutationOptions<AdminUpdateVideoStatus200, ResponseErrorConfig<AdminUpdateVideoStatus422>, AdminUpdateVideoOptions, TContext>

  return useMutation<AdminUpdateVideoStatus200, ResponseErrorConfig<AdminUpdateVideoStatus422>, AdminUpdateVideoOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<AdminUpdateVideoStatus200, ResponseErrorConfig<AdminUpdateVideoStatus422>, AdminUpdateVideoOptions, TContext>
}
